import { css } from 'lit';
export const styles = css`.m-quote-carousel__title-wrapper{width:100%}@media(min-width: 1024px){.m-quote-carousel__title-wrapper{width:75%}}.m-quote-carousel__body-wrapper{margin-top:50px}@media(min-width: 1024px){.m-quote-carousel__body-wrapper{margin-top:-50px}}`;
